<template>
  <div
    v-tooltip="{
      content: text,
      html: true,
    }"
    class="info-bubble"
    :class="[sizeClass, `info-bubble--${color}`]"
  >
    <div class="info-bubble__container">
      <span class="info-bubble__label">{{ getIconText }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoBubbleTooltip',
  props: {
    iconText: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'teal',
      validator: (value) => ['teal', 'navy'].includes(value),
    },
    size: {
      type: String,
      default: 'sub-middle',
      validator: (value) => ['small', 'sub-middle'].includes(value),
    },
  },
  computed: {
    getIconText() {
      return this.iconText ? this.iconText : '?'
    },
    sizeClass() {
      return this.size === 'sub-middle' ? '' : `info-bubble--${this.size}`
    },
  },
}
</script>
